import Image from "antd/es/image";
import React, {useEffect, useRef, useState} from "react";
import {Anchor, Row, Col, Card, Space, Radio} from 'antd';
import {useTranslation} from "react-i18next";
import { Scrollbars } from 'react-custom-scrollbars'
import axios from "axios";

export default (prop) => {

    const {t} = useTranslation()
    const ref = useRef()

    const [typeBtn, setTypeBtn] = useState()

    let group = {}
    let result = []

    for (const item of prop.data) {
        if (!group[item.type]) {
            group[item.type] = []
            result.push(item.type)
        }
        group[item.type].push(item)
    }
    let sortMap = {
        bilibili: 1,
        baidu: 3,
        touhou: 2,
    }
    result.sort((a, b) => {
        let aa = sortMap[a] || 99
        let bb = sortMap[b] || 99
        return aa - bb
    })

    useEffect(() => {

        if (result.length > 0) {
            setTypeBtn(result[0])
        }
    }, [prop.data])

    function getRadioEle(type) {
        return document.querySelector(`#radio_${type}`)
    }

    function getCardEle(type) {
        return document.querySelector(`#card_${type}`)
    }


    return <>
        {
            <Space direction={"vertical"}>
                <Scrollbars onScrollStop={(e) => {

                    for (let i = 0; i < result.length; i++) {
                        const type = result[i]
                        let cardEle = getCardEle(type)

                        let y = ref.current.parentElement.getBoundingClientRect().y - cardEle.getBoundingClientRect().y;

                        if (y + 20 > cardEle.scrollHeight) {
                            continue
                        } else {
                            setTypeBtn(type)
                            getRadioEle(type).scrollIntoViewIfNeeded()
                            break
                        }

                    }


                }} style={{height: '400px', width: '418px'}}>
                    <div ref={ref} style={{ height: '400px', width: '400px'}}>
                        {
                            result.map((type) => {
                                return <Card id={`card_${type}`} style={{width: '100%'}} size={'small'} bordered={false} key={type} title={t(`emoji.${type}`)}>
                                    {
                                        group[type].map(item => <Card.Grid onClick={() => {
                                            prop.click(item.id)
                                        }} key={item.id} style={{ width: '12.5%', height: '40px',}}>
                                            <Image draggable={"false"} style={{marginTop: '-20px', marginLeft: '-20px'}} src={`${axios.defaults.fileURL}touhou/emoji/${item.id}.png`} preview={false} width={40} height={40} />
                                        </Card.Grid>)
                                    }
                                </Card>
                            })
                        }
                    </div>
                </Scrollbars>
                <Scrollbars style={{ height: '40px', width: '400px' }}>
                    <Radio.Group style={{ width: "400px", whiteSpace: 'nowrap', }} options={
                        result.map(type => {return {label: <span id={`radio_${type}`}>{t(`emoji.${type}`)}</span>, value: type}})
                    } onChange={(e) => {
                        setTypeBtn(e.target.value)
                        getCardEle(e.target.value).scrollIntoViewIfNeeded()
                    }
                    } value={typeBtn} optionType="button"  buttonStyle="solid" />
                </Scrollbars>



            </Space>



        }
    </>

}
